import { render, staticRenderFns } from "./ComissaoNovo.vue?vue&type=template&id=a03b1fca"
import script from "./ComissaoNovo.vue?vue&type=script&lang=js"
export * from "./ComissaoNovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports